import { apiUrl } from '../utils/constants'

const basePath = 'public/secure-documents'

/**
 * Llamadas al endpoint público de documentos seguros (sin autenticación).
 * GET public/secure-documents/:uuid → validar UUID
 * POST public/secure-documents/:uuid/request-otp con { sent_to } → solicitar envío de OTP
 * POST public/secure-documents/:uuid/verify-otp-download con { code } → validar OTP y obtener PDF
 */

function publicFetch(url, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  }
  return fetch(`${apiUrl}${url}`, {
    ...options,
    headers,
  })
}

/**
 * Valida que el UUID exista y esté habilitado para acceso público.
 * @param {string} uuid
 * @returns {Promise<{ data?: object, error?: object }>}
 */
export async function validateSecureDocumentUuid(uuid) {
  try {
    const response = await publicFetch(`${basePath}/${uuid}`, { method: 'GET' })
    const json = await response.json()
    if (response.ok) return { data: json, error: null }
    return { data: null, error: json }
  } catch (err) {
    return { data: null, error: err }
  }
}

/**
 * Solicita el envío del código OTP. El backend lee el teléfono del link directamente.
 * @param {string} uuid
 * @returns {Promise<{ data?: object, error?: object }>}
 */
export async function requestSecureDocumentOtp(uuid) {
  try {
    const response = await publicFetch(`${basePath}/${uuid}/request-otp`, {
      method: 'POST',
    })
    const json = await response.json()
    if (response.ok) return { data: json, error: null }
    return { data: null, error: json }
  } catch (err) {
    return { data: null, error: err }
  }
}

/**
 * Valida el código OTP y obtiene el PDF (blob o datos para visualización).
 * La respuesta puede ser application/pdf (blob) o JSON con url/base64.
 * @param {string} uuid
 * @param {{ code: string }} body
 * @returns {Promise<{ data?: Blob|object, error?: object }>}
 */
export async function validateSecureDocumentOtpAndGetPdf(uuid, body) {
  try {
    const response = await publicFetch(`${basePath}/${uuid}/verify-otp-download`, {
      method: 'POST',
      body: JSON.stringify(body),
    })
    const contentType = response.headers.get('content-type') || ''
    if (contentType.includes('application/pdf')) {
      const blob = await response.blob()
      if (response.ok) return { data: blob, error: null }
      return { data: null, error: { message: 'Invalid response' } }
    }
    const json = await response.json()
    if (response.ok) return { data: json, error: null }
    return { data: null, error: json }
  } catch (err) {
    return { data: null, error: err }
  }
}
